var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseApplyManageService } from "~/services/business-service/case-apply-manage.service";
var collectionManageModule = namespace("collection-manage");
var ForeignVisits = /** @class */ (function (_super) {
    __extends(ForeignVisits, _super);
    function ForeignVisits() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false,
        };
        _this.userData = [];
        _this.model = {
            caseId: "",
            flowType: "VISIT_APPLY",
            applyRemark: "",
            visitTimeStart: "",
            visitTimeEnd: "",
            addressDetail: "",
            addressType: "",
            personalName: "",
            personalAddressId: "",
            personalContactId: "",
            relationShip: "",
            caseType: "",
        };
        _this.rules = {
            visitTimeStart: [{ required: true, message: "请选择外访开始时间", trigger: "change" }],
            visitTimeEnd: [{ required: true, message: "请选择外访结束时间", trigger: "change" }],
            applyRemark: [{ required: true, message: "请输入外访原因", trigger: "blur" }],
        };
        return _this;
    }
    ForeignVisits.prototype.close = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    ForeignVisits.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.model.personalId = _this.currentCase.personalId;
            // 案件id
            _this.model.caseId = _this.caseId;
            // 地址信息
            _this.model.addressDetail = _this.currentAddress.addressDetail;
            // 地址类型
            _this.model.addressType = _this.currentAddress.type;
            // 姓名
            _this.model.personalName = _this.currentAddress.name;
            // 地址id
            _this.model.personalAddressId = _this.currentAddress.id;
            // id
            _this.model.personalContactId = _this.currentAddress.id;
            // 关系
            _this.model.relationShip = _this.currentAddress.relation;
            //案件类型
            _this.model.caseType = _this.otherData.caseType;
            _this.loading.state = true;
            _this.caseApplyManageService.caseApplyOperated(_this.model, _this.loading).subscribe(function (data) {
                _this.$message.success("申请外访成功!");
                _this.updateAssistCount();
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(CaseApplyManageService)
    ], ForeignVisits.prototype, "caseApplyManageService", void 0);
    __decorate([
        collectionManageModule.State
    ], ForeignVisits.prototype, "caseId", void 0);
    __decorate([
        collectionManageModule.State
    ], ForeignVisits.prototype, "currentCase", void 0);
    __decorate([
        collectionManageModule.State
    ], ForeignVisits.prototype, "otherData", void 0);
    __decorate([
        collectionManageModule.Mutation
    ], ForeignVisits.prototype, "updateAssistCount", void 0);
    __decorate([
        Prop()
    ], ForeignVisits.prototype, "currentAddress", void 0);
    __decorate([
        Emit("close")
    ], ForeignVisits.prototype, "close", null);
    ForeignVisits = __decorate([
        Component({
            components: {},
        })
    ], ForeignVisits);
    return ForeignVisits;
}(Vue));
export default ForeignVisits;
